import * as React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import clsx from "clsx";

const StyledButton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    textTransform: "none",
    width: "100%",
    height: theme.spacing(6),
    padding: `0 ${theme.spacing(3)}px`,
    borderRadius: theme.shape.full,
    fontSize: theme.typography.body2.fontSize,
    boxShadow: "none",
    maxWidth: 305,
    color: "white",
    transition: "background-color 150ms ease, box-shadow 150ms ease",
    "&.default": {
      backgroundColor: theme.palette.grey.main,
    },
    "&.default:hover": {
      backgroundColor: theme.palette.grey.dark,
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow: theme.boxShadow.elevation2,
      filter: "brightness(1.05)",
    },
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    "&:active": {
      boxShadow: "none",
    },
    "&:disabled": {
      backgroundColor: theme.palette.grey.disabled,
      color: theme.palette.text.secondary,
    },
    "&.small": {
      height: theme.spacing(4),
      fontSize: theme.typography.caption.fontSize,
    },
    "&.medium": {
      height: theme.spacing(5),
      fontSize: theme.typography.caption.fontSize,
    },
  },
  label: {
    fontFamily: theme.typography.interFontStack,
    fontWeight: theme.typography.fontWeightBold,
    [theme.breakpoints.down("sm")]: {
      fontSize: 11,
      lineHeight: 1.2,
    },
  },
}))(Button);

export default function SexierButton({
  isLoading,
  children,
  className,
  size,
  color,
  ...props
}) {
  return (
    <StyledButton
      {...props}
      className={clsx(className, size, color)}
      disabled={Boolean(isLoading) || Boolean(props.disabled)}
    >
      {isLoading ? <CircularProgress size="2rem" /> : children}
    </StyledButton>
  );
}

SexierButton.propTypes = {
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
  color: PropTypes.oneOf(["default"]),
};
